import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function CheckboxCheckedIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask id="path-1-inside-1_1556_1501" fill="white">
          <path d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2Z" />
        </mask>
        <path
          d="M2 1H22V-1H2V1ZM23 2V22H25V2H23ZM22 23H2V25H22V23ZM1 22V2H-1V22H1ZM2 23C1.44772 23 1 22.5523 1 22H-1C-1 23.6569 0.343145 25 2 25V23ZM23 22C23 22.5523 22.5523 23 22 23V25C23.6569 25 25 23.6569 25 22H23ZM22 1C22.5523 1 23 1.44772 23 2H25C25 0.343146 23.6569 -1 22 -1V1ZM2 -1C0.343146 -1 -1 0.343145 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
          fill={theme.palette.main.professional_blue}
          mask="url(#path-1-inside-1_1556_1501)"
        />
        <path
          d="M5 12L10 17L19 7"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
